// Purpose: Keeps BayHive status surfaces and the purple Info treatment.
const bayhiveStatusTag = (tone) => ({
  background: `light-dark({${tone}.700}, {${tone}.300})`,
  color: `{${tone}.contrast.color}`,
});

const purpleInfoMessage = {
  background: 'light-dark(color-mix(in srgb, {info.50}, transparent 5%), color-mix(in srgb, {info.500}, transparent 84%))',
  borderColor: 'transparent',
  color: '{info.text.color}',
  closeButton: {
    hoverBackground: 'light-dark({info.100}, rgba(255, 255, 255, 0.05))',
    focusRing: {
      color: '{focus.ring.color}',
      shadow: '{info.focus.ring.shadow}',
    },
  },
  outlined: {
    color: '{info.text.color}',
    borderColor: 'light-dark({info.700}, {info.300})',
  },
  simple: {
    color: '{info.text.color}',
  },
};

const purpleInfoToast = {
  background: 'light-dark(color-mix(in srgb, {info.50}, transparent 5%), color-mix(in srgb, {info.500}, transparent 84%))',
  borderColor: 'light-dark({info.500}, color-mix(in srgb, {info.700}, transparent 64%))',
  color: '{info.text.color}',
  detailColor: 'light-dark({surface.700}, {surface.0})',
  closeButton: {
    hoverBackground: 'light-dark({info.100}, rgba(255, 255, 255, 0.05))',
    focusRing: {
      color: '{focus.ring.color}',
      shadow: '{info.focus.ring.shadow}',
    },
  },
};

export const feedbackComponents = {
  badge: {
    success: bayhiveStatusTag('success'),
  },
  message: {
    info: purpleInfoMessage,
  },
  tag: {
    success: bayhiveStatusTag('success'),
    info: {
      background: 'light-dark({info.600}, {info.400})',
      color: 'light-dark({surface.0}, {info.contrast.color})',
    },
  },
  toast: {
    info: purpleInfoToast,
  },
};

export default feedbackComponents;
